export const state = () => ({
  daysList: {},
  filters: {
    resourcesType: 'all',
    status: 'ready',
    page: 1,
    pageSize: 100
  },
  publications: [],
  isFormEditing: false,
  ignoreAnimation: false,
  selectedPublication: null,
  isCalendarOpen: false
})

export const mutations = {
  setCalendarOpen(state, newFlag) {
    state.isCalendarOpen = newFlag
  },

  setDaysList(state, newDayList) {
    state.daysList = {...state.daysList, ...newDayList}
  },

  setPublications(state, newPublications) {
    state.publications = newPublications
  },

  addPublications(state, newPublications) {
    state.publications.push(...newPublications)
  },

  setSelectedPublication(state, newSelectedPub) {
    state.selectedPublication = newSelectedPub
  },

  updatePublication(state, newPublication) {
    state.publications = state.publications.map(pub => {
      if(pub.id === newPublication.id)
        return {...pub, ...newPublication}
      return pub
    })
  },

  setPublicationReady(state, id) {
    state.publications.forEach(item => {
      if(item.id === id)
        item.setReady()
    })
    state.selectedPublication.setReady()
  },

  setPublicationReadyToBeSent(state, id) {
    state.publications.forEach(item => {
      if(item.id === id)
        item.setEnqueued()
    })
  },

  setPublicationDiscarded(state, id) {
    state.publications.forEach(item => {
      if(item.id === id)
        item.setDiscarded()
    })
    state.isFormEditing = false
  },

  setFormEditing(state, newFlag) {
    state.isFormEditing = newFlag
  },

  setIgnoreAnimation(state, newFlag) {
    state.ignoreAnimation = newFlag
  },

  setFilters(state, newFilters) {
    state.filters = { ...state.filters, ...newFilters }
  }
}

export const actions = {
  setPublicationReadyToBeSent({ commit }, publication) {
    commit('setIgnoreAnimation', false)

    commit('updatePublication', publication)
    commit('setPublicationReadyToBeSent', publication.id)
    commit('setFormEditing', false)
  },

  setPublicationSaved({ commit }, publication) {
    commit('setIgnoreAnimation', false)
    
    commit('updatePublication', publication)
    commit('setFormEditing', false)
  },

  setPublicationDiscarded({ commit }, publication) {
    commit('setIgnoreAnimation', true)

    commit('setPublicationDiscarded', publication.id)
    commit('setFormEditing', false)
  },

  updateFromWs({ commit }, eventPayload) {
    commit('setIgnoreAnimation', true)

    switch (eventPayload.type) {
      case 'publication':
        commit('updatePublication', eventPayload.data)
        break
    }
  }
}

export const getters = {
  daysList(state) {
    return state.daysList
  },

  dayListByDate: (state) => (date) => {
    return state.daysList[date]
  },

  dayListCountByDate: (state) => (date, key = 'count_ready') => {
    return Object.values(state.daysList[date])
                 .reduce((t, obj) => t + obj[key], 0)
  },

  publications(state) {
    return state.publications
  },

  selectedPublication(state) {
    return state.selectedPublication
  },

  isFormEditing(state) {
    return state.isFormEditing
  },

  isIgnoreAnimation(state) {
    return state.ignoreAnimation
  },

  isCalendarOpen(state) {
    return state.isCalendarOpen
  },
  
  filters(state) {
    return state.filters
  }
}
